/** Тренер: модальное окно профиля клиента (ClientProfileModal). */
export const CLIENT_PROFILE_RU = {
  'clientProfile.title': 'Профиль клиента',
  'clientProfile.edit': 'Изменить',
  'clientProfile.changePhoto': 'Изменить фото',
  'clientProfile.statusActive': 'Активен',
  'clientProfile.statusInactive': 'Не активен',
  'clientProfile.displayNameFallback': 'Клиент',
  'clientProfile.trainerComment': 'Комментарий',
  'clientProfile.editTrainerComment': 'Редактировать комментарий',
  'clientProfile.deleteTrainerComment': 'Удалить комментарий',
  'clientProfile.deleteTrainerCommentTitle': 'Удалить комментарий?',
  'clientProfile.deleteTrainerCommentDesc':
    'Комментарий будет удалён. Это действие можно отменить, снова отредактировав профиль.',
  'clientProfile.metricsHeight': 'Рост',
  'clientProfile.metricsWeight': 'Вес',
  'clientProfile.editProfileTitle': 'Редактирование профиля',
  'clientProfile.savingProfile': 'Сохранение...',
  'clientProfile.saveProfileChanges': 'Сохранить изменения',
  'clientProfile.nameLabel': 'Имя',
  'clientProfile.namePlaceholder': 'Имя клиента',
  'clientProfile.clientNoteLabel': 'Комментарий',
  'clientProfile.clientNotePlaceholder': 'Заметка о клиенте...',
  'clientProfile.navCalendar': 'Календарь',
  'clientProfile.navExercises': 'Упражнения',
  'clientProfile.navPayments': 'Оплаты',
  'clientProfile.workoutsHeading': 'Тренировки',
  'clientProfile.openPaymentCalendar': 'Календарь оплат',
  'clientProfile.paymentCalendarAndSessions': 'Календарь оплат и занятий',
  'clientProfile.upcoming': 'Предстоящие',
  'clientProfile.past': 'Прошедшие',
  'clientProfile.loading': 'Загрузка...',
  'clientProfile.loadingExercises': 'Загрузка упражнений...',
  'clientProfile.noUpcomingWorkouts': 'Нет предстоящих тренировок',
  'clientProfile.noPastWorkouts': 'Нет прошедших тренировок',
  'clientProfile.paginationShown': 'Показаны {from}-{to} из {total} тренировок',
  'clientProfile.pageOf': 'Страница {page} из {pages}',
  'clientProfile.back': 'Назад',
  'clientProfile.next': 'Далее',
  'clientProfile.exercisesHeading': 'Упражнения',
  'clientProfile.addExerciseBtn': 'Добавить упражнение',
  'clientProfile.addExerciseWithWeight': 'Добавить упражнение и вес',
  'clientProfile.searchExercisePlaceholder': 'Поиск упражнения...',
  'clientProfile.noExercisesEmpty': 'Нет упражнений',
  'clientProfile.noExercisesFound': 'Упражнения не найдены',
  'clientProfile.colExercise': 'Упражнение',
  'clientProfile.colWorkingWeightKg': 'Рабочий вес, кг',
  'clientProfile.editWorkingWeightTitle': 'Редактировать рабочий вес',
  'clientProfile.deleteProfileBtn': 'Удалить профиль',
  'clientProfile.deleteProfileAria': 'Удалить профиль клиента',
  'clientProfile.paymentCalendarTitle': 'Календарь оплат',
  'clientProfile.paymentCalendarDesc': 'Календарь оплат по месяцам',
  'clientProfile.legendPaid': 'Оплачено',
  'clientProfile.legendUnpaid': 'Не оплачено',
  'clientProfile.legendPaidCount': 'Количество оплаченных тренировок',
  'clientProfile.addWorkoutTitle': 'Добавить тренировку',
  'clientProfile.addWorkoutIntro': 'Создайте новую тренировку для клиента {name}',
  'clientProfile.rescheduleNewDate': 'Новая дата',
  'clientProfile.rescheduleNewTime': 'Новое время',
  'clientProfile.comboboxEmpty': 'Упражнение не найдено в словаре',
  'clientProfile.comboboxCreate': 'Добавить в мой словарь',
  'clientProfile.comboboxHint': 'Выберите упражнение из списка или введите новое название',
  'clientProfile.standardExercises': 'Стандартные упражнения',
  'clientProfile.myDictionary': 'Мой словарь',
  'clientProfile.addSetShort': 'Добавить',
  'clientProfile.addSetLong': 'Добавить подход',
  'clientProfile.addAnotherSet': 'Добавить еще подход',
  'clientProfile.volumeTotal': 'Общий объем: {kg} {unit}',
  'clientProfile.unitKg': 'кг',
  'clientProfile.editWorkoutTitle': 'Редактировать тренировку',
  'clientProfile.editWorkoutHint': 'Измените детали тренировки',
  'clientProfile.exerciseConfirmNo': 'Нет',
  'clientProfile.exerciseConfirmYes': 'Да, добавить',
  'clientProfile.deleteClientTitle': 'Удаление профиля клиента',
  'clientProfile.deleteClientLabel': 'Клиент:',
  'clientProfile.deleteDeactivateTitle': 'Сделать неактивным',
  'clientProfile.deleteDeactivateDesc':
    'Будущие тренировки удаляются/отменяются. Прошедшие тренировки, история оплат, упражнения и рабочие веса сохраняются. Клиент скрывается из списка.',
  'clientProfile.deleteFullTitle': 'Удалить полностью',
  'clientProfile.deleteFullDesc':
    'Удаляются все данные: тренировки, оплаты, упражнения, рабочие веса. Это действие нельзя отменить.',
  'clientProfile.deleting': 'Выполняется...',
  'clientProfile.deleteFullConfirm': 'Удалить полностью',
  'clientProfile.deleteDeactivateConfirm': 'Сделать неактивным',
  'clientProfile.deleteWorkoutTitle': 'Удалить тренировку',
  'clientProfile.deleteWorkoutConfirm': 'Вы уверены, что хотите удалить тренировку на {date} в {time}?',
  'clientProfile.recurringWorkout': 'Это повторяющаяся тренировка',
  'clientProfile.deleteThisOnly': 'Удалить только эту тренировку',
  'clientProfile.deleteWholeSeries': 'Удалить всю серию повторяющихся тренировок',
  'clientProfile.deleteSeries': 'Удалить серию',
  'clientProfile.deleteWorkoutAction': 'Удалить тренировку',
  'clientProfile.exerciseLinePrefix': 'Упражнение:',
  'clientProfile.errInvalidWeightValue': 'Введите корректное значение веса',
  'clientProfile.enterWeightPlaceholder': 'Введите вес',
  'clientProfile.manualExerciseIntro': 'Выберите упражнение из справочника.',
  'clientProfile.searchLabel': 'Поиск',
  'clientProfile.searchExerciseStart': 'Начните вводить название…',
  'clientProfile.manualListEmpty': 'Ничего не найдено или всё уже в списке',
  'clientProfile.selectedLabel': 'Выбрано:',
  'clientProfile.workingWeightKgLabel': 'Рабочий вес, кг',
  'clientProfile.weightExample': 'Например, 40',
  'clientProfile.pickAvatar': 'Выберите аватар',
  'clientProfile.addExerciseToWorkout': 'Добавьте новое упражнение к тренировке на {date}',
  'clientProfile.chosenDateFallback': 'выбранную дату',

  'clientProfile.dictExerciseAdded': 'Упражнение «{name}» добавлено в ваш словарь',
  'clientProfile.errLoadClient': 'Ошибка при загрузке данных клиента',
  'clientProfile.errPaymentCalLoad': 'Не удалось загрузить календарь оплат',
  'clientProfile.errWithMessage': 'Ошибка: {msg}',
  'clientProfile.successWorkoutCancelled': 'Тренировка успешно отменена',
  'clientProfile.errCancelWorkout': 'Ошибка при отмене тренировки',
  'clientProfile.successWorkoutMoved': 'Тренировка успешно перенесена',
  'clientProfile.errTransferWorkout': 'Ошибка при переносе тренировки',
  'clientProfile.errCommentDeleteNotFound': 'Клиент не найден',
  'clientProfile.errCommentDeleteServer': 'Ошибка сервера при удалении комментария',
  'clientProfile.errCommentDelete': 'Ошибка при удалении комментария',
  'clientProfile.phoneSaved': 'Номер телефона сохранен',
  'clientProfile.phoneCleared': 'Номер телефона удален',
  'clientProfile.errPhone': 'Ошибка при сохранении номера телефона',
  'clientProfile.instagramSaved': 'Instagram сохранен',
  'clientProfile.instagramCleared': 'Instagram удален',
  'clientProfile.errInstagram': 'Ошибка при сохранении Instagram',
  'clientProfile.emailSaved': 'Email сохранен',
  'clientProfile.emailCleared': 'Email удален',
  'clientProfile.errEmail': 'Ошибка при сохранении email',
  'clientProfile.weightSaved': 'Вес сохранен',
  'clientProfile.weightCleared': 'Вес удален',
  'clientProfile.errWeight': 'Ошибка при сохранении веса',
  'clientProfile.heightSaved': 'Рост сохранен',
  'clientProfile.heightCleared': 'Рост удален',
  'clientProfile.errHeight': 'Ошибка при сохранении роста',
  'clientProfile.genderSaved': 'Пол сохранен',
  'clientProfile.genderCleared': 'Пол удален',
  'clientProfile.errGender': 'Ошибка при сохранении пола',
  'clientProfile.avatarUpdated': 'Аватар обновлен',
  'clientProfile.errAvatarUpdate': 'Ошибка при обновлении аватара',
  'clientProfile.errPickImage': 'Пожалуйста, выберите изображение',
  'clientProfile.errFileSize5mb': 'Размер файла не должен превышать 5 МБ',
  'clientProfile.avatarUploaded': 'Аватарка обновлена',
  'clientProfile.errAvatarUpload': 'Ошибка при загрузке аватара',
  'clientProfile.errFileRead': 'Ошибка при чтении файла',
  'clientProfile.errFileProcess': 'Ошибка при обработке файла',
  'clientProfile.profileUpdated': 'Профиль обновлен',
  'clientProfile.errProfileSave': 'Ошибка при сохранении профиля',
  'clientProfile.successSetUpdated': 'Подход обновлен успешно',
  'clientProfile.errSetUpdate': 'Ошибка при обновлении подхода',
  'clientProfile.successSetDeleted': 'Подход удален успешно',
  'clientProfile.errSetDelete': 'Ошибка при удалении подхода',
  'clientProfile.successWorkoutAdded': 'Тренировка успешно добавлена',
  'clientProfile.errWorkoutAdd': 'Ошибка при добавлении тренировки',
  'clientProfile.errTimeConflictShort': 'Конфликт времени: {clients}',
  'clientProfile.errRecurringConflict':
    'Конфликт при создании повторяющейся тренировки на {date} в {time}. Занято: {clients}',
  'clientProfile.successWorkoutUpdated': 'Тренировка успешно обновлена',
  'clientProfile.errWorkoutUpdate': 'Ошибка при обновлении тренировки',
  'clientProfile.errWorkoutNotFound': 'Тренировка не найдена',
  'clientProfile.successSeriesDeleted': 'Удалено {n} тренировок из серии',
  'clientProfile.errWorkoutDelete': 'Ошибка при удалении тренировки',
  'clientProfile.errNoteAdd': 'Ошибка при добавлении заметки',
  'clientProfile.toastClientDeleted': 'Клиент и все его данные удалены',
  'clientProfile.toastClientDeactivatedN': 'Клиент сделан неактивным. Удалено {n} будущих тренировок',
  'clientProfile.toastClientDeactivated': 'Клиент сделан неактивным',
  'clientProfile.errDeleteClient': 'Ошибка при удалении клиента',
  'clientProfile.errDeactivateClient': 'Ошибка при деактивации клиента',
  'clientProfile.exerciseInList': 'Это упражнение уже есть в списке',
  'clientProfile.enterWorkingWeight': 'Укажите рабочий вес',
  'clientProfile.errWorkingWeightInvalid': 'Введите корректный рабочий вес',
  'clientProfile.manualExerciseAdded': 'Упражнение добавлено',
  'clientProfile.errSaveFailed': 'Не удалось сохранить',
  'clientProfile.successWorkingWeightUpdated': 'Рабочий вес обновлен',
  'clientProfile.errNickname': 'Не удалось подобрать никнейм',

  'clientProfile.successWorkoutDeleted': 'Тренировка успешно удалена',
  'clientProfile.errSetRepsInvalid':
    'Подход {n}: введите корректное целое число повторений',
  'clientProfile.errSetWeightInvalid':
    'Подход {n}: введите корректный вес (число с запятой или точкой, или оставьте пустым)',
  'clientProfile.errDictExerciseExists': 'Упражнение уже есть в словаре',
  'clientProfile.errSaveExerciseToDict': 'Ошибка при сохранении упражнения',
  'clientProfile.paymentCalPrevMonth': 'Предыдущий месяц',
  'clientProfile.paymentCalNextMonth': 'Следующий месяц',
};

export const CLIENT_PROFILE_EN = {
  'clientProfile.title': 'Client profile',
  'clientProfile.edit': 'Edit',
  'clientProfile.changePhoto': 'Change photo',
  'clientProfile.statusActive': 'Active',
  'clientProfile.statusInactive': 'Inactive',
  'clientProfile.displayNameFallback': 'Client',
  'clientProfile.trainerComment': 'Note',
  'clientProfile.editTrainerComment': 'Edit note',
  'clientProfile.deleteTrainerComment': 'Delete note',
  'clientProfile.deleteTrainerCommentTitle': 'Delete note?',
  'clientProfile.deleteTrainerCommentDesc':
    'The note will be removed. You can undo by editing the profile again.',
  'clientProfile.metricsHeight': 'Height',
  'clientProfile.metricsWeight': 'Weight',
  'clientProfile.editProfileTitle': 'Edit profile',
  'clientProfile.savingProfile': 'Saving...',
  'clientProfile.saveProfileChanges': 'Save changes',
  'clientProfile.nameLabel': 'Name',
  'clientProfile.namePlaceholder': 'Client name',
  'clientProfile.clientNoteLabel': 'Note',
  'clientProfile.clientNotePlaceholder': 'Note about the client...',
  'clientProfile.navCalendar': 'Calendar',
  'clientProfile.navExercises': 'Exercises',
  'clientProfile.navPayments': 'Payments',
  'clientProfile.workoutsHeading': 'Workouts',
  'clientProfile.openPaymentCalendar': 'Payment calendar',
  'clientProfile.paymentCalendarAndSessions': 'Payments & sessions calendar',
  'clientProfile.upcoming': 'Upcoming',
  'clientProfile.past': 'Past',
  'clientProfile.loading': 'Loading...',
  'clientProfile.loadingExercises': 'Loading exercises...',
  'clientProfile.noUpcomingWorkouts': 'No upcoming workouts',
  'clientProfile.noPastWorkouts': 'No past workouts',
  'clientProfile.paginationShown': 'Showing {from}-{to} of {total} workouts',
  'clientProfile.pageOf': 'Page {page} of {pages}',
  'clientProfile.back': 'Back',
  'clientProfile.next': 'Next',
  'clientProfile.exercisesHeading': 'Exercises',
  'clientProfile.addExerciseBtn': 'Add exercise',
  'clientProfile.addExerciseWithWeight': 'Add exercise & weight',
  'clientProfile.searchExercisePlaceholder': 'Search exercise...',
  'clientProfile.noExercisesEmpty': 'No exercises yet',
  'clientProfile.noExercisesFound': 'No exercises found',
  'clientProfile.colExercise': 'Exercise',
  'clientProfile.colWorkingWeightKg': 'Working weight, kg',
  'clientProfile.editWorkingWeightTitle': 'Edit working weight',
  'clientProfile.deleteProfileBtn': 'Remove client',
  'clientProfile.deleteProfileAria': 'Remove client profile',
  'clientProfile.paymentCalendarTitle': 'Payment calendar',
  'clientProfile.paymentCalendarDesc': 'Monthly payment overview',
  'clientProfile.legendPaid': 'Paid',
  'clientProfile.legendUnpaid': 'Unpaid',
  'clientProfile.legendPaidCount': 'Number of prepaid sessions logged',
  'clientProfile.addWorkoutTitle': 'Add workout',
  'clientProfile.addWorkoutIntro': 'Schedule a new session for {name}',
  'clientProfile.rescheduleNewDate': 'New date',
  'clientProfile.rescheduleNewTime': 'New time',
  'clientProfile.comboboxEmpty': 'Exercise not in dictionary',
  'clientProfile.comboboxCreate': 'Add to my dictionary',
  'clientProfile.comboboxHint': 'Pick from the list or type a new name',
  'clientProfile.standardExercises': 'Standard exercises',
  'clientProfile.myDictionary': 'My dictionary',
  'clientProfile.addSetShort': 'Add',
  'clientProfile.addSetLong': 'Add set',
  'clientProfile.addAnotherSet': 'Add another set',
  'clientProfile.volumeTotal': 'Total volume: {kg} {unit}',
  'clientProfile.unitKg': 'kg',
  'clientProfile.editWorkoutTitle': 'Edit workout',
  'clientProfile.editWorkoutHint': 'Update session details',
  'clientProfile.exerciseConfirmNo': 'No',
  'clientProfile.exerciseConfirmYes': 'Yes, add it',
  'clientProfile.deleteClientTitle': 'Remove client',
  'clientProfile.deleteClientLabel': 'Client:',
  'clientProfile.deleteDeactivateTitle': 'Deactivate',
  'clientProfile.deleteDeactivateDesc':
    'Future sessions are removed or cancelled. Past sessions, payments, exercises and working weights stay. The client is hidden from your list.',
  'clientProfile.deleteFullTitle': 'Delete completely',
  'clientProfile.deleteFullDesc':
    'Removes everything: workouts, payments, exercises, working weights. This cannot be undone.',
  'clientProfile.deleting': 'Working...',
  'clientProfile.deleteFullConfirm': 'Delete completely',
  'clientProfile.deleteDeactivateConfirm': 'Deactivate',
  'clientProfile.deleteWorkoutTitle': 'Delete workout',
  'clientProfile.deleteWorkoutConfirm': 'Delete the workout on {date} at {time}?',
  'clientProfile.recurringWorkout': 'This is a repeating workout',
  'clientProfile.deleteThisOnly': 'Delete only this session',
  'clientProfile.deleteWholeSeries': 'Delete the whole repeating series',
  'clientProfile.deleteSeries': 'Delete series',
  'clientProfile.deleteWorkoutAction': 'Delete workout',
  'clientProfile.exerciseLinePrefix': 'Exercise:',
  'clientProfile.errInvalidWeightValue': 'Enter a valid weight',
  'clientProfile.enterWeightPlaceholder': 'Enter weight',
  'clientProfile.manualExerciseIntro': 'Pick an exercise from the catalog.',
  'clientProfile.searchLabel': 'Search',
  'clientProfile.searchExerciseStart': 'Start typing a name…',
  'clientProfile.manualListEmpty': 'Nothing found or already in the list',
  'clientProfile.selectedLabel': 'Selected:',
  'clientProfile.workingWeightKgLabel': 'Working weight, kg',
  'clientProfile.weightExample': 'e.g. 40',
  'clientProfile.pickAvatar': 'Choose avatar',
  'clientProfile.addExerciseToWorkout': 'Add a new exercise to the workout on {date}',
  'clientProfile.chosenDateFallback': 'the selected date',

  'clientProfile.dictExerciseAdded': 'Exercise “{name}” added to your dictionary',
  'clientProfile.errLoadClient': 'Couldn’t load client data',
  'clientProfile.errPaymentCalLoad': 'Couldn’t load payment calendar',
  'clientProfile.errWithMessage': 'Error: {msg}',
  'clientProfile.successWorkoutCancelled': 'Workout cancelled',
  'clientProfile.errCancelWorkout': 'Couldn’t cancel workout',
  'clientProfile.successWorkoutMoved': 'Workout rescheduled',
  'clientProfile.errTransferWorkout': 'Couldn’t reschedule workout',
  'clientProfile.errCommentDeleteNotFound': 'Client not found',
  'clientProfile.errCommentDeleteServer': 'Server error while deleting note',
  'clientProfile.errCommentDelete': 'Couldn’t delete note',
  'clientProfile.phoneSaved': 'Phone number saved',
  'clientProfile.phoneCleared': 'Phone number removed',
  'clientProfile.errPhone': 'Couldn’t save phone number',
  'clientProfile.instagramSaved': 'Instagram saved',
  'clientProfile.instagramCleared': 'Instagram removed',
  'clientProfile.errInstagram': 'Couldn’t save Instagram',
  'clientProfile.emailSaved': 'Email saved',
  'clientProfile.emailCleared': 'Email removed',
  'clientProfile.errEmail': 'Couldn’t save email',
  'clientProfile.weightSaved': 'Weight saved',
  'clientProfile.weightCleared': 'Weight removed',
  'clientProfile.errWeight': 'Couldn’t save weight',
  'clientProfile.heightSaved': 'Height saved',
  'clientProfile.heightCleared': 'Height removed',
  'clientProfile.errHeight': 'Couldn’t save height',
  'clientProfile.genderSaved': 'Gender saved',
  'clientProfile.genderCleared': 'Gender removed',
  'clientProfile.errGender': 'Couldn’t save gender',
  'clientProfile.avatarUpdated': 'Avatar updated',
  'clientProfile.errAvatarUpdate': 'Couldn’t update avatar',
  'clientProfile.errPickImage': 'Please choose an image',
  'clientProfile.errFileSize5mb': 'File must be 5 MB or smaller',
  'clientProfile.avatarUploaded': 'Avatar uploaded',
  'clientProfile.errAvatarUpload': 'Couldn’t upload avatar',
  'clientProfile.errFileRead': 'Couldn’t read file',
  'clientProfile.errFileProcess': 'Couldn’t process file',
  'clientProfile.profileUpdated': 'Profile updated',
  'clientProfile.errProfileSave': 'Couldn’t save profile',
  'clientProfile.successSetUpdated': 'Set updated',
  'clientProfile.errSetUpdate': 'Couldn’t update set',
  'clientProfile.successSetDeleted': 'Set deleted',
  'clientProfile.errSetDelete': 'Couldn’t delete set',
  'clientProfile.successWorkoutAdded': 'Workout added',
  'clientProfile.errWorkoutAdd': 'Couldn’t add workout',
  'clientProfile.errTimeConflictShort': 'Time conflict: {clients}',
  'clientProfile.errRecurringConflict':
    'Conflict creating repeating workout on {date} at {time}. Taken by: {clients}',
  'clientProfile.successWorkoutUpdated': 'Workout updated',
  'clientProfile.errWorkoutUpdate': 'Couldn’t update workout',
  'clientProfile.errWorkoutNotFound': 'Workout not found',
  'clientProfile.successSeriesDeleted': 'Deleted {n} workouts from series',
  'clientProfile.errWorkoutDelete': 'Couldn’t delete workout',
  'clientProfile.errNoteAdd': 'Couldn’t add note',
  'clientProfile.toastClientDeleted': 'Client and all data removed',
  'clientProfile.toastClientDeactivatedN': 'Client deactivated. Removed {n} future workouts',
  'clientProfile.toastClientDeactivated': 'Client deactivated',
  'clientProfile.errDeleteClient': 'Couldn’t remove client',
  'clientProfile.errDeactivateClient': 'Couldn’t deactivate client',
  'clientProfile.exerciseInList': 'This exercise is already in the list',
  'clientProfile.enterWorkingWeight': 'Enter working weight',
  'clientProfile.errWorkingWeightInvalid': 'Enter a valid working weight',
  'clientProfile.manualExerciseAdded': 'Exercise added',
  'clientProfile.errSaveFailed': 'Couldn’t save',
  'clientProfile.successWorkingWeightUpdated': 'Working weight updated',
  'clientProfile.errNickname': 'Couldn’t generate nickname',

  'clientProfile.successWorkoutDeleted': 'Workout deleted',
  'clientProfile.errSetRepsInvalid':
    'Set {n}: enter a valid rep count (whole numbers only)',
  'clientProfile.errSetWeightInvalid':
    'Set {n}: enter a valid weight (decimal with dot or comma, or leave blank)',
  'clientProfile.errDictExerciseExists': 'This exercise is already in your dictionary',
  'clientProfile.errSaveExerciseToDict': 'Couldn’t save exercise',
  'clientProfile.paymentCalPrevMonth': 'Previous month',
  'clientProfile.paymentCalNextMonth': 'Next month',
};
